"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsIcon = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const SettingsIcon = () => /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "53",
  height: "53",
  viewBox: "0 0 53 53",
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "settings",
    transform: "translate(0.5 0.5)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      id: "Ellipse_39",
      "data-name": "Ellipse 39",
      cx: "10",
      cy: "10",
      r: "10",
      transform: "translate(16 16)",
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "Path_19108",
      "data-name": "Path 19108",
      d: "M42.818,32.818a3.75,3.75,0,0,0,.75,4.136l.136.136a4.548,4.548,0,1,1-6.432,6.432l-.136-.136a3.78,3.78,0,0,0-6.409,2.682v.386a4.545,4.545,0,1,1-9.091,0v-.2a3.75,3.75,0,0,0-2.455-3.432,3.75,3.75,0,0,0-4.136.75l-.136.136a4.548,4.548,0,1,1-6.432-6.432l.136-.136a3.78,3.78,0,0,0-2.682-6.409H5.545a4.545,4.545,0,1,1,0-9.091h.2a3.75,3.75,0,0,0,3.432-2.455,3.75,3.75,0,0,0-.75-4.136L8.3,14.909a4.548,4.548,0,1,1,6.432-6.432l.136.136A3.75,3.75,0,0,0,19,9.364h.182a3.75,3.75,0,0,0,2.273-3.432V5.545a4.545,4.545,0,1,1,9.091,0v.2a3.78,3.78,0,0,0,6.409,2.682l.136-.136a4.548,4.548,0,1,1,6.432,6.432l-.136.136A3.75,3.75,0,0,0,42.636,19v.182a3.75,3.75,0,0,0,3.432,2.273h.386a4.545,4.545,0,1,1,0,9.091h-.2A3.75,3.75,0,0,0,42.818,32.818Z",
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3"
    })]
  })
});
exports.SettingsIcon = SettingsIcon;
